/* import __COLOCATED_TEMPLATE__ from './stages.hbs'; */
import Component from '@glimmer/component';
import FilterConstants from '../../filter-constants';
import { DetailsOfStage } from './schematic';

interface StagesFiguresArgs {
  model: StagesModel;
  options: { xscale: string; yscale: string };
}

type StagesModel = {
  detailsOfStages: DetailsOfStage[];
  responseType: string;
  nthOrder: string;
  filterResponseValue: string;
};

export default class StagesFigure extends Component<StagesFiguresArgs> {
  get numberOfStages(): number {
    return this.args.model.detailsOfStages.length;
  }

  get isChebyshevFilterResponse(): boolean {
    return this.args.model.responseType === FilterConstants.responseType.chebyshev;
  }
}
